import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * shadcn/ui's class helper: merge conditional classes, last-wins on conflicts.
 *
 * `twMerge` is what makes a variant overridable from a call site — passing
 * `className="text-slate"` beats the variant's own `text-ink` instead of both
 * landing and the cascade deciding by source order.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
